<sh-basic-chart [model]="model"></sh-basic-chart>
